import React, { Component } from 'react';
import { loadScript } from './loadScript';


let lastEditorId = 0;
export default class extends Component {



  constructor(props) {
    super(props);
    this.editorId = props.editorId || `editor-${++lastEditorId}`;
  }

  componentDidMount() {

    loadScript(this.loadEditor);

  }

  render() {
    let {
      props: { minHeight = 500, style = {} },
    } = this;

    return (
      <div
        style={{
          flex: 1,
          display: 'flex',
          minHeight: minHeight,
        }}
      >
        <div id={this.editorId} style={{ ...style, flex: 1 }} />
      </div>
    );
  }

  loadEditor = () => {
    const options = this.props.options || {};

    if (this.props.projectId) {
      options.projectId = this.props.projectId;
    }

    if (this.props.tools) {
      console.log('tools', this.props.tools)
      options.tools = this.props.tools;
    }

    if (this.props.appearance) {
      options.appearance = this.props.appearance;
    }

    if (this.props.locale) {
      options.locale = this.props.locale;
    }

    console.log('options', options)
    this.editor = window.unlayer.createEditor({
      ...options,
      id: this.editorId,
      displayMode: 'email',
      // displayMode: 'web',
      source: {
        name: "react-email-editor",
        version: "1.3.0",
      },
    });

  

    // All properties starting with on[Name] are registered as event listeners.
    for (const [key, value] of Object.entries(this.props)) {
      if (/^on/.test(key) && key != 'onLoad') {
        this.addEventListener(key, value);
      }
    }

    const { onLoad } = this.props;
    onLoad && onLoad();
  };

  registerCallback = (type, callback) => {
    this.editor.registerCallback(type, callback);
  };

  addEventListener = (type, callback) => {
    this.editor.addEventListener(type, callback);
  };

  loadDesign = (design) => {
    this.editor.loadDesign(design);
  };

  saveDesign = (callback) => {
    this.editor.saveDesign(callback);
  };

  exportHtml = (callback) => {
    this.editor.exportHtml((data) => {
      const { html, design } = data || {};

      let finalHtml = html || '';

      if (finalHtml) {
        const bodyOpenTagMatch = finalHtml.match(/<body\b[^>]*>/i);
        const bodyCloseTag = /<\/body\s*>/i;

        // 1) Espaciador superior para evitar recorte de primer elemento
        if (!this.props?.disableTopSpacer) {
          const spacer = '<table role="presentation" width="100%" cellspacing="0" cellpadding="0"><tr><td height="1" style="font-size:1px;line-height:1px;">&nbsp;</td></tr></table>';
          if (bodyOpenTagMatch) {
            const openTag = bodyOpenTagMatch[0];
            finalHtml = finalHtml.replace(openTag, `${openTag}${spacer}`);
          } else {
            finalHtml = `${spacer}${finalHtml}`;
          }
        }

        // 2) Preheader oculto opcional
        if (this.props?.preheaderText) {
          const preheader = `<div style=\"display:none!important;visibility:hidden;mso-hide:all;font-size:1px;line-height:1px;color:#ffffff;max-height:0;max-width:0;opacity:0;overflow:hidden;\">${this.props.preheaderText}</div>`;
          if (bodyOpenTagMatch) {
            const openTag = bodyOpenTagMatch[0];
            finalHtml = finalHtml.replace(openTag, `${openTag}${preheader}`);
          } else {
            finalHtml = `${preheader}${finalHtml}`;
          }
        }

        // 3) Píxel de tracking al cierre del body
        if (this.props?.trackingPixelUrl) {
          const trackingImg = `<img src=\"${this.props.trackingPixelUrl}\" width=\"1\" height=\"1\" style=\"display:block;width:1px;height:1px;opacity:0;\" alt=\"\" />`;
          if (bodyCloseTag.test(finalHtml)) {
            finalHtml = finalHtml.replace(bodyCloseTag, `${trackingImg}</body>`);
          } else {
            finalHtml = `${finalHtml}${trackingImg}`;
          }
        }

        // 4) Normalización de estilos del modo web: evitar layout flex en el contenedor
        //    - Cambia display:flex -> display:block en atributos style
        //    - Elimina min-height:100vh de atributos style
        finalHtml = finalHtml
          .replace(/style=("[^"]*?)display\s*:\s*flex;?([^\"]*?")/gi, (match, pre, post) => {
            return `style=${pre}display:block;${post}`;
          })
          .replace(/min-height\s*:\s*100vh;?/gi, '');
      }

      callback({ html: finalHtml, design });
    });
  };

  setMergeTags = (mergeTags) => {
    this.editor.setMergeTags(mergeTags);
  };
}